export enum Claims {
  Eidas_FamilyName = "http://eidas.europa.eu/attributes/naturalperson/CurrentFamilyName",
  Eidas_FirstName = "http://eidas.europa.eu/attributes/naturalperson/CurrentGivenName",
  Eidas_DateOfBirth = "http://eidas.europa.eu/attributes/naturalperson/DateOfBirth",
  Eidas_PersonIdentifier = "http://eidas.europa.eu/attributes/naturalperson/PersonIdentifier",
  Eidas_CurrentAddress = "http://eidas.europa.eu/attributes/naturalperson/CurrentAddress",
  Eidas_IsVerified = "http://eidas.europa.eu/attributes/naturalperson/IsVerified",
  Eidas_LegalPersonIsVerified = "http://eidas.europa.eu/attributes/legalperson/IsVerified",
  Eidas_LegalName = "http://eidas.europa.eu/attributes/legalperson/LegalName",
  Eidas_LegalPersonIdentifier = "http://eidas.europa.eu/attributes/legalperson/LegalPersonIdentifier",

  Eidas_VATRegistration = "http://eidas.europa.eu/attributes/legalperson/VATRegistrationNumber",

  Nota_HasCourtPortal = "http://pocztaprawnicz.pl/hasCourtPortal",

  UserProfessionClaim = "http://pocztaprawnicza.pl/atributes/user/profession",
  UserBarAssociationClaim = "http://pocztaprawnicza.pl/atributes/user/barassociation",
  UserLicenseClaim = "http://pocztaprawnicza.pl/atributes/user/licensenumber",

  UserStatusClaim = "http://pocztaprawnicza.pl/atributes/user/status",
  UserTypeClaim = "http://doreczeniaelektroniczne.pl/atributes/user/type",

  UserIsSwitchedToAnotherUser = "http://pocztaprawnicz.pl/atributes/subaccount/switch/active",
  UserSwitchedToUserId = "http://pocztaprawnicz.pl/atributes/subaccount/userId",
  UserSwitchedToUserLabel = "http://pocztaprawnicz.pl/atributes/subaccount/label",

  EDelivery_KRS = "http://doreczeniaelektroniczne.pl/atributes/legalperson/krs",
  EDelivery_REGON = "http://doreczeniaelektroniczne.pl/atributes/legalperson/regon",

  Email = "email",
  invitation = "invitation",
  GivenName = "given_name",
  FamilyName = "family_name",

  Country = "http://schemas.xmlsoap.org/ws/2005/05/identity/claims/country",
}
